// extracted by mini-css-extract-plugin
export default {"root":"_2IShL","icon":"_3w2qS","active-icon":"_2AGN-","activeIcon":"_2AGN-"};